"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EventHandler_1 = require("../Framework/EventHandler");
class PropertyChangeModel {
    constructor() {
        this.executing = false;
        this.dispatchingEnabled = true;
        this.events = new EventHandler_1.default();
    }
    enableDispatching(enable) {
        this.dispatchingEnabled = enable;
    }
    addChangeListener(handler) {
        this.events.on('change', handler);
    }
    removeChangeListener(handler) {
        this.events.off('change', handler);
    }
    propertyChanged(propertyName, oldValue, newValue) {
        if (this.dispatchingEnabled === false) {
            return;
        }
        if (oldValue === newValue) {
            return;
        }
        if (this.executing) {
            throw new Error('Not allowed to change state while there is a state change in progress');
        }
        this.executing = true;
        this.events.trigger('change', [newValue, oldValue, propertyName]);
        this.executing = false;
    }
}
exports.default = PropertyChangeModel;
//# sourceMappingURL=PropertyChangeModel.js.map